export default {
  body: "'GothamRounded-Medium', Helvetica, Arial, sans-serif",
  heading: "'GothamRounded-Bold', Helvetica,Arial, sans-serif",
  mono: "'GothamRounded-Book', monospace",
  digit: "'GothamRounded-Light', Helvetica, Arial, sans-serif",
}
